import type { GenericId as Id } from "convex/values";
import { api } from "../lib/api";
import { useCachedQuery } from "./useCachedQuery";

export function useArtists(editionId: string) {
  return useCachedQuery(
    api.queries.widget.artists,
    { editionId: editionId as Id<"editions"> },
    "artists",
    editionId
  );
}

export function useArtist(artistId: string, editionId: string) {
  return useCachedQuery(
    api.queries.widget.artist,
    { artistId: artistId as Id<"edition_artists">, editionId: editionId as Id<"editions"> },
    `artist:${artistId}`,
    editionId
  );
}

export function useSchedules(editionId: string) {
  return useCachedQuery(
    api.queries.widget.schedules,
    { editionId: editionId as Id<"editions"> },
    "schedules",
    editionId
  );
}

export function useEvents(editionId: string) {
  return useCachedQuery(
    api.queries.widget.events,
    { editionId: editionId as Id<"editions"> },
    "events",
    editionId
  );
}

export function useEvent(eventId: string, editionId: string) {
  return useCachedQuery(
    api.queries.widget.event,
    { eventId: eventId as Id<"edition_events">, editionId: editionId as Id<"editions"> },
    `event:${eventId}`,
    editionId
  );
}

export function usePlaces(editionId: string) {
  return useCachedQuery(
    api.queries.widget.places,
    { editionId: editionId as Id<"editions"> },
    "places",
    editionId
  );
}

export function usePlace(placeId: string, editionId: string) {
  return useCachedQuery(
    api.queries.widget.place,
    { placeId: placeId as Id<"places">, editionId: editionId as Id<"editions"> },
    `place:${placeId}`,
    editionId
  );
}

export function useEditionData(editionId: string) {
  return useCachedQuery(
    api.queries.widget.edition,
    { editionId: editionId as Id<"editions"> },
    "edition",
    editionId
  );
}
